import { useCallback, useEffect } from 'react';

import { accountsActions } from '@store/accounts/accounts.slice';

import { useStoreDispatch, useStoreSelector } from '@hook/store/store.hooks';
import { useAuthorized } from '@hook/user/use-authorized.hook';
import { useUserMeta } from '@hook/user/use-user-meta.hook';
import { isExist } from '@util/data/is-exist';

export const useCurrentAccount = () => {
  const dispatch = useStoreDispatch();
  const {
    data,
    isLoaded,
    isLoading,
    meta: { currentId },
    error,
  } = useStoreSelector((state) => state.accounts);
  const { isAuthorized } = useAuthorized();
  const {
    meta: { accountId: accountLocalId = '' },
  } = useUserMeta();

  const current = data[currentId] ?? data[accountLocalId] ?? Object.values(data).at(0);

  useEffect(() => {
    if (isExist(current)) {
      if (currentId !== current.id) void dispatch(accountsActions.setCurrentAccount(current.id));
    }
  }, [current, currentId, accountLocalId, isAuthorized]);

  const onChange = useCallback((value: string) => void dispatch(accountsActions.setCurrentAccount(value)), [dispatch]);

  return {
    isLoading,
    isLoaded,
    current,
    onChange,
    error,
  };
};
